
/*
 * Copyright (c) 2022 by Leyton Group - All Rights Reserved.
 * This source code, and resulting software, is the confidential and proprietary information
 * ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 * of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 * and shall use it only in accordance with the terms and conditions of any and all license
 * agreements you have entered into with The Company.
 */


import axios from 'axios';
import {pathConstants} from '@/shared/pathConstants';
import store from '@/store';
import {cloneDeep} from 'lodash';

const SHOW_LOADER = 'loader/showAddRoleLoader';
const HIDE_LOADER = 'loader/hideAddRoleLoader';

const fetchRoles = function(pagedFilter) {
    const customPagedFilter = cloneDeep(pagedFilter);
    if (customPagedFilter.myPager.page > 1) {
        customPagedFilter.myPager.page = customPagedFilter.myPager.page - 1;
    } else {
        customPagedFilter.myPager.page = 0;
    }
    return axios.post(pathConstants.API + '/roles/clientRoles', customPagedFilter)
        .then(roles => roles.data)
        .catch(error => error);
};

const createRole = function(addRoleDto) {
    store.commit(SHOW_LOADER);
    return axios.post(pathConstants.API + '/roles/create_role', addRoleDto)
        .then(response => {
            store.commit(HIDE_LOADER);
            return response.data;
        })
        .catch(error => {
            store.commit(HIDE_LOADER);
            return error;
        });
};

const modifyRole = function(modifyRoleDto) {
    store.commit(SHOW_LOADER);
    return axios.post(pathConstants.API + '/roles/modify_role', modifyRoleDto)
        .then(response => {
            store.commit(HIDE_LOADER);
            return response.data;
        })
        .catch(error => {
            store.commit(HIDE_LOADER);
            return error;
        });
};

const deleteRole = function(id) {
    store.commit(SHOW_LOADER);
    return axios.delete(`${pathConstants.API}/roles/delete_role/${id}` )
        .then(response => {
            store.commit(HIDE_LOADER);
            return response.data;
        })
        .catch(error => {
            store.commit(HIDE_LOADER);
            return error;
        });
};

export const roleService = {
    fetchRoles,
    createRole,
    modifyRole,
    deleteRole
};
